__turbopack_context__.v({
  "actionButton": "styles-module__cZSY4W__actionButton",
  "activeHeading": "styles-module__cZSY4W__activeHeading",
  "activeHeadingText": "styles-module__cZSY4W__activeHeadingText",
  "productListContainer": "styles-module__cZSY4W__productListContainer",
  "qrModalContainer": "styles-module__cZSY4W__qrModalContainer",
  "qrModalDownloadButton": "styles-module__cZSY4W__qrModalDownloadButton",
  "rearrangeButtons": "styles-module__cZSY4W__rearrangeButtons",
  "rearrangeButtonsContainer": "styles-module__cZSY4W__rearrangeButtonsContainer",
  "rearrangeButtonsContainerThrift": "styles-module__cZSY4W__rearrangeButtonsContainerThrift",
  "rearrangeModeActiveButton": "styles-module__cZSY4W__rearrangeModeActiveButton",
  "seeMoreText": "styles-module__cZSY4W__seeMoreText",
  "sellerLikesUsername": "styles-module__cZSY4W__sellerLikesUsername",
  "shopDropWrapper": "styles-module__cZSY4W__shopDropWrapper",
});
